
import Konva from 'konva';
import { ScaleAdjustmentValue } from './getScaleFactor';
import { getCanvasText, getCanvasLine } from "./konva/getCanvas";
import { DrawRoof } from './roof/draw_roof';
import { RoofShape } from './roof/RoofShape';


export class DrawScale {

	colorLight: string = "#333333"; // Scale light color
	textColor: string = "#000000"; // scale count text color
	textScale: number = 0;
	scaleStartingPoint: number = 100;
	incrementStep: number = 100;
	layer: Konva.Layer;
	nRoofHeight: number;
	nRoofWidth: number;
	background(stage: Konva.Stage) {
		var backgroundLayer = new Konva.Layer();
		let smallScale = Math.round(100 / 10);
		let grid = '<svg width="' + stage.width() + '" height="' + stage.height() + '" xmlns="http://www.w3.org/2000/svg">\n' +
			'    <defs>\n' +
			'        <pattern id="smallGrid" width="' + smallScale + '" height="' + smallScale + '" patternUnits="userSpaceOnUse">\n' +
			'            <path d="M ' + smallScale + ' 0 L 0 0 0 ' + smallScale + '" fill="none" stroke="gray" stroke-width="0.5" />\n' +
			'        </pattern>\n' +
			'        <pattern id="grid" width="' + 100 + '" height="' + 100 + '" patternUnits="userSpaceOnUse">\n' +
			'            <rect width="' + 100 + '" height="' + 100 + '" fill="url(#smallGrid)" />\n' +
			'            <path d="M ' + 100 + ' 0 L 0 0 0 ' + 100 + '" fill="none" stroke="gray" stroke-width="1" />\n' +
			'        </pattern>\n' +
			'    </defs>\n' +
			'\n' +
			'    <rect width="100%" height="100%" fill="url(#grid)" />\n' +
			'</svg>';
		let url = 'data:image/svg+xml;base64,' + btoa(grid);
		let img = new Image();
		img.onload = () => {
			img.width = this.nRoofWidth;
			img.height = this.nRoofHeight;
			let bgImage = new Konva.Image({
				image: img,
				x: ScaleAdjustmentValue.getScaleAdjust(0),
				y: ScaleAdjustmentValue.getScaleAdjust(0),
			});
			backgroundLayer.removeChildren();
			backgroundLayer.add(bgImage);
			backgroundLayer.draw();
		};
		img.src = url;
		stage.add(backgroundLayer);

	}
	//draw scale on roof
	drawScale(stage: Konva.Stage, l: Konva.Layer) {
		this.nRoofHeight = RoofShape.getCurrentRoofHeight() + 250;
		this.nRoofWidth = RoofShape.getCurrentRoofWidth() + 250;
		if (RoofShape.getCurrentRoofHeight() < 5000 && RoofShape.getCurrentRoofWidth() < 5000) {
			this.incrementStep = 100;
			this.scaleStartingPoint = 100;
			ScaleAdjustmentValue.initValue = 100;
			this.background(stage)
		} else {
			this.incrementStep = 400;
			this.scaleStartingPoint = 400;
			ScaleAdjustmentValue.initValue = 180;
			
		}
		this.layer = l;
		var maxW: number = this.nRoofWidth;
		var maxH: number = this.nRoofHeight;
		// this.incrementStep = 100 * ScaleAdjustmentValue.scaleDivisionNumber;
		var currentPostion: number = this.scaleStartingPoint;
		// Draw Horizontal Lines 
		while (currentPostion <= maxH) {
			// this.drawLine(this.scaleStartingPoint, currentPostion, maxW, currentPostion, true);
			if (currentPostion % 100 == 0)
				this.writeScale(50, currentPostion, "y", currentPostion - 100);
			currentPostion += this.incrementStep;
		}
		// Draw vertical Lines
		currentPostion = this.scaleStartingPoint;
		while (currentPostion <= maxW) {
			// this.drawLine(currentPostion, this.scaleStartingPoint, currentPostion, maxH, false);
			if (currentPostion % 100 == 0)
				this.writeScale(currentPostion, 50, "x", currentPostion - 100);
			currentPostion += this.incrementStep;
		}
		this.layer.draw();

	}
	// by using Konva drawLines
	drawLine(x1: number, y1: number, x2: number, y2: number, horizontal: boolean) {
		var colorCode: string = this.colorLight;
		var line = getCanvasLine({
			points: [x1, y1, x2, y2],
			stroke: colorCode,
			strokeWidth: 1,
		});
		this.layer.add(line);
		this.layer.draw();
	}
	// write scale count in meters
	writeScale(x: number, y: number, axis: string, textScale: number) {
		var text = getCanvasText({
			x: axis == 'x' ? x - 10 : x - 20,
			y: axis == 'y' ? y - 10 : y,
			// text: axis == 'y' ? (RoofShape.getCurrentRoofHeight() - textScale) / 100 + 'm' : textScale / 100 + 'm',
			text: textScale / 100 + 'm',
			fontSize: 25,
			fontFamily: 'Calibri',
			fill: this.textColor,
		});
		var x1: number = 0, x2: number = 0, y1: number = 0, y2: number = 0;
		if (axis == 'x') {
			x1 = x + 0;
			x2 = x + 0;
			y1 = y + 30;
			y2 = y + 50;
		}
		if (axis == 'y') {
			x1 = x + 35;
			x2 = x + 50;
			y1 = y + 0;
			y2 = y + 0;
		}

		var line = getCanvasLine({
			points: [x1, y1, x2, y2],
			stroke: this.textColor,
			strokeWidth: 1,
		});
		this.layer.add(text);
		this.layer.add(line);

	}
}